<template>
  <div>
    <div class="question-text" v-html="questionText"></div>
    <button @click="next" class="next active">Next</button>
  </div>
</template>

<script>
export default {
    name: 'no-choice',

    props: {
        data: {
            required: true,
            type: Object
        }
    },

    computed: {
        questionText() {
            const index = this.data.text.findIndex(a => a.lang == this.$parent.lang)
            return this.data.text[index].html;
        }
    },

    methods: {
        next() {
            this.$emit('next-question')
        }
    }
}
</script>